/**
 * Loading Products Context
 *
 * Holds the IDs of products whose gallery image is still loading, so a just-
 * selected product's checkbox can show a spinner until the preview updates.
 *
 * @package
 */

import { createContext } from '@wordpress/element';

export const LoadingProductsContext = createContext( [] );
